import * as Mod1 from "./discourse/connectors/admin-user-details/patreon.gjs";
import * as Mod2 from "./discourse/connectors/topic-above-footer-buttons/patreon.gjs";
import * as Mod3 from "./discourse/controllers/admin-plugins/patreon";
import * as Mod4 from "./discourse/initializers/patreon-admin-plugin-configuration-nav";
import * as Mod5 from "./discourse/initializers/patreon";
import * as Mod6 from "./discourse/models/filter-rule";
import * as Mod7 from "./discourse/patreon-route-map";
import * as Mod8 from "./discourse/routes/admin-plugins/patreon";
import * as Mod9 from "./discourse/templates/admin/plugins-patreon";
const compatModules = {
  "discourse/connectors/admin-user-details/patreon": Mod1,
  "discourse/connectors/topic-above-footer-buttons/patreon": Mod2,
  "discourse/controllers/admin-plugins/patreon": Mod3,
  "discourse/initializers/patreon-admin-plugin-configuration-nav": Mod4,
  "discourse/initializers/patreon": Mod5,
  "discourse/models/filter-rule": Mod6,
  "discourse/patreon-route-map": Mod7,
  "discourse/routes/admin-plugins/patreon": Mod8,
  "discourse/templates/admin/plugins-patreon": Mod9,
};
export default compatModules;
